import { Box, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./ExactForm.module.scss";
import PageTitle from "../../components/pageTitle/PageTitle";
import i18next from "i18next";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import _, { isNull } from "lodash";
import Button from "../../components/buttons/Buttons";
import ExactTable from "./ExactTable";
import { ReactComponent as RadioIcon } from "../../assets/icons/Radio.svg";
import { ReactComponent as RadioUncheck } from "../../assets/icons/RadioUncheck.svg";
import { EXACT_CLIENT_ID, EXACT_REDIRECTION_URL } from "../../config/appConfig";
import { FormLabel } from "react-bootstrap";
import CustomModalDialog from "../../components/modal/CustomModalDialog";
import CustomSnackbar from "../../components/customSnackBar/CustomSnackbar";
import { GetExactSetting, UpdateExactAppSetting } from "../../services/APIService";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";

const ExactFrame = () => {
  const { setApiErrorModalState } = useApiErrorModalContext();
  const queries = queryString.parse(useLocation().search);
  let tokenCode = _.get(queries, "code", null);
  const history = useNavigate();
  const [allSync, setAllSync] = useState(false);
  const [fullRefresh, setFullRefresh] = useState(false);
  const [linkClicked, setLinkClicked] = useState(false);
  const [isShowConfirmation, setShowConfirmation] = useState(false);
  const [isShowSuccessMessage, setIsShowSuccessMessage] = useState(false);
  const [exactSetting, setExactSetting] = useState("automatic");
  const [isFullRefreshAllowed, setIsFullRefreshAllowed] = useState(true);
  const [showFullRefreshAlert, setShowFullRefreshAlert] = useState(false);

  const handleLoginClick = (e) => {
    if (linkClicked) {
      e.preventDefault();
    } else {
      setLinkClicked(true);
    }
  }

  useEffect(() => {
    GetExactSetting()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          setApiErrorModalState({ error: response });
        } else {
          setExactSetting(response?.value);
        }
      }).catch((err) => {
        setApiErrorModalState({ error: err });
      });
  }, [])

  // Add this effect to reset fullRefresh after each attempt
  useEffect(() => {
    if (!allSync && fullRefresh) {
      setFullRefresh(false);
    }
  }, [allSync, fullRefresh]);

  return (
    <Box className={`${styles.exactFormWrapper}`} data-testid="ExactFrame">
      <PageTitle
        title={`${i18next.t("Beheersomgeving Exact-koppeling")}`}
        data-testid="pagetitle"
      />

      <Box className={styles.noteHeader}>
        {!isNull(tokenCode) ? (
          <Box className={styles.exactSyncContainer}>
            <Box className={styles.exactSyncText}>
              "Let op: Wacht met sluiten of refreshen van het tabblad tot het
              proces is afgerond"
            </Box>
            <Box className={styles.exactSyncButton}>
              <Box sx={{ display: 'none' }}>
                <Button
                  title="Alles Sync"
                  iconStyle={""}
                  buttonType="muibtn-primary"
                  withIcon={false}
                  attriType={"submit"}
                  isDisabled={allSync}
                  handleClick={() => {
                    setAllSync(true);
                    setFullRefresh(false);
                  }
                  }
                />
              </Box>
              <Button
                title="Full Refresh"
                iconStyle={""}
                buttonType="muibtn-primary"
                withIcon={false}
                attriType={"submit"}
                isDisabled={allSync}
                handleClick={() => {
                  if (!isFullRefreshAllowed) {
                    setShowFullRefreshAlert(true);
                    return;
                  }
                  setAllSync(true);
                  setFullRefresh(true);
                }}
              />
            </Box>
          </Box>
        ) : null}
      </Box>

      <Box className={styles.buttonSectionWrapper}>
        <Box className={styles.buttonWrapper}>
          {isNull(tokenCode) ? (
            <>
              <a
                // ="noopener noreferrer"
                href={`https://start.exactonline.nl/api/oauth2/auth?client_id=${EXACT_CLIENT_ID}&redirect_uri=${EXACT_REDIRECTION_URL}&response_type=code`}
                target="framename"
              >
                <Button
                  title="Inloggen in Exact"
                  iconStyle={""}
                  buttonType="muibtn-primary"
                  withIcon={false}
                  attriType={"submit"}
                  handleClick={handleLoginClick}
                />
              </a>
              <Button
                title="Terug naar homepage"
                iconStyle={""}
                buttonType="muibtn-secondary"
                withIcon={false}
                attriType={"submit"}
                handleClick={() => history("/")}
              />
            </>
          ) : (
            <ExactTable
              code={tokenCode}
              allSync={allSync}
              fullRefresh={fullRefresh}
              setAllSync={setAllSync}
              onFullRefreshAllowedChange={setIsFullRefreshAllowed}
              onFullRefreshAttempt={() => setShowFullRefreshAlert(true)}
            />
          )}
        </Box>
        <FormControl>
          <FormLabel id="exact-radio-group-label">{i18next.t("Exact synchronization not active? switch to manual")}</FormLabel>
          <RadioGroup
            aria-labelledby="exact-radio-group"
            value={exactSetting}
            name="status-buttons-group"
            className={styles.radioGroup}
            onChange={(e) => {
              const selectedValue = _.get(e, "target.value", "");
              setExactSetting(selectedValue);
              UpdateExactAppSetting(selectedValue).then((response) => {
                setIsShowSuccessMessage(true);
              }).catch((err) => {
                setApiErrorModalState({ error: err });
              });
            }}
          >
            <FormControlLabel
              key={'automatic'}
              value={'automatic'}
              control={
                <Radio
                  icon={<RadioUncheck />}
                  checkedIcon={<RadioIcon />}
                />
              }
              label={i18next.t("Automatic")}
            />
            <FormControlLabel
              key={'manual'}
              value={'manual'}
              control={
                <Radio
                  icon={<RadioUncheck />}
                  checkedIcon={<RadioIcon />}
                />
              }
              label={i18next.t("Manually (only in case of Exact fault)")}
            />
          </RadioGroup>
        </FormControl>
        <Box>
          {/* <CustomModalDialog
          isShow={isShowConfirmation}
          title="confirmation"
          onClose={() => setShowConfirmation(false)}
          isCloseButton={false}
          doScrollToTop={false}
          isShowHeader={true}
          hasFooter={true}
          cancelBtnLabel="No"
          primaryButnFn={() => {
            //resetExactFields();
            setShowConfirmation(false);
          }}
          primaryBtnLabel="Yes"
          handleClose={() => setShowConfirmation(false)}
        >
          <Box>{i18next.t("Do you want to continue?")}</Box>
        </CustomModalDialog> */}
          <CustomSnackbar
            open={isShowSuccessMessage}
            message={"Saved Successfully"}
            setOpen={setIsShowSuccessMessage}
          />
          <CustomSnackbar
            open={showFullRefreshAlert}
            message={"Refresh is not allowed within 2 hours of the last refresh."}
            setOpen={setShowFullRefreshAlert}
            successMessage={false}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ExactFrame;
